import {
  Component,
  OnInit,
  Input,
  Output,
  ViewEncapsulation,
  EventEmitter,
  ElementRef,
  SimpleChanges,
  OnChanges
, ChangeDetectionStrategy } from '@angular/core';
import { includes } from 'lodash';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ui-multicombobox',
  templateUrl: './multicombobox.component.html',
  styleUrls: ['../combobox/combobox.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class MulticomboboxComponent implements OnChanges, OnInit {
  constructor(private el: ElementRef) {}
  @Input() initBy;
  @Input() items;
  @Input() textKey;
  @Input() defaultText;
  @Input() nullChoice;
  @Input() isDisabled;
  @Input() name;
  @Input() isCanSelectAll = false;
  @Input() sortByFn;

  @Output() callback = new EventEmitter<any>();
  @Output() searchStrChange = new EventEmitter<string | null>();

  searchText = '';
  isAllItemsSelected = false;

  ngOnInit() {
    this.defaultText = this.defaultText || 'Выберите значение';
  }

  chooseItem(item): void {
    this.items.forEach(i => {
      if (i.name === item.name) {
        i.checked = !i.checked;
      }
    });

    this.isAllItemsSelected = this.checkIsAllItemsSelected();
    this.callback.emit(this.selectedItems());
  }

  handleOpen() {
    this.items = this.sortByFn ? this.sortByFn([...this.items]) : this.items;
  }

  selectedItems() {
    return this.items.filter(filteredItem => filteredItem.checked);
  }

  checkIsAllItemsSelected(): boolean {
    return this.items.every(item => item.checked === true);
  }

  getSelected(): string {
    return this.selectedItems().map(item => item.name).join(', ');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.searchStrChange.emit(this.searchText);

      if (this.initBy) {
        this.initBy = this.initBy.map(item => item.id);

        this.items.forEach(i => {
          if (includes(this.initBy, i.id)) {
            i.checked = true;
          }
        });

        this.isAllItemsSelected = this.checkIsAllItemsSelected();
      }
    }
  }

  onClickSelectAllItems() {
    this.isAllItemsSelected = !this.isAllItemsSelected;
    this.items.forEach(i => i.checked = this.isAllItemsSelected);
    this.callback.emit(this.selectedItems());
  }

  changeInput(event): void {
    this.items.forEach(i => {
      if (includes(event.target.value.toLowerCase(), i.name.toLowerCase())) {
        i.checked = true;
      } else {
        i.checked = false;
      }
    });

    this.isAllItemsSelected = this.checkIsAllItemsSelected();
    this.callback.emit(this.items.filter(item => item.checked));
  }

  toggled(isOpen): void {
    if (!isOpen) {
      this.el.nativeElement.querySelector('.js-ui-combobox__field').blur();
    }
  }
}
